import React from 'react'
import TableHeader from '../../Shared/TableHeader'
import { Col, Row } from 'react-bootstrap'
import BarCharts from './BarCharts'

const OrderAnalytics = () => {
    return (
        <>
        <TableHeader headerValue={"Order Analytics"}/>
            <Row>
            <Col className="slide-chatbox" xs={12}>
                   <BarCharts/>
                </Col>
            </Row>
        </>
    )
}

export default OrderAnalytics